module.exports = __webpack_public_path__ + "img/section3.03f7de99.png";